import { useSelector } from "react-redux";
import { environment } from "../util";
import { IADPState } from "../Types/AppStateTypes";
import { useIPCBridge } from "./useIPCBridge";
const logPrefix = "[RedirectService]"
export function useRedirectionService() {
    const state = useSelector((state:{rootState:IADPState})=>state.rootState)
    const {setKioskMode} = useIPCBridge();
    //const {saveADPChromeAppState,startAssessment} = useIPCBridge();TODO readd when the ipc bridge is added
    function redirectToSCI(){
        let url = `${environment.resolveENAEPDomain()}/login/index.html?`;
        // if(state.sessionState.selectedAssessmentMode === "ncs" && state.connectedNCSState){ TODO implement npn version of this endpoint
        //     url =`${state.connectedNCSState.config.staticServices.assessmentEntryUrl}&`
        // }
        let urlWithParams = `${url}adpLaunchId=${state.appState.appLaunchId}&setupcode=${state.sessionState.schoolDetails?.setupCode}&deviceId=${state.deviceState.deviceId}&locale=${state.sessionState.schoolDetails?.isPR ? "es" :"en"}&version=${state.appState.releaseVersion}&assessmentMode=online`;//TODO add in when you figure out how npn is going to work &assessmentMode=${state.sessionState.selectedAssessmentMode}
        if(state.sessionState.selectedAssessmentLocation?.locationId && state.sessionState.selectedAssessmentLocation?.label){
            urlWithParams = `${urlWithParams}&selectedAssessmentLocationLabel=${state.sessionState.selectedAssessmentLocation?.label}&selectedAssessmentLocationLocationId=${state.sessionState.selectedAssessmentLocation?.locationId}`
        }
        console.log(logPrefix,"redirecting to:", url);
            //saveADPChromeAppState(state);
            //startAssessment();
            setTimeout(()=>{
                setKioskMode()
            //if(state.sessionState.selectedAssessmentMode === "online"){
                window.location.replace(urlWithParams);
            // }TODO readd when we add in the npn implementation
            // else if(state.sessionState.selectedAssessmentMode === "ncs"){
            //     const appState = {
            //                         clientLaunchId: state.appState.appLaunchId ,
            //                         content: state.staticContent,
            //                         selectedAssessmentMode: state.sessionState?.selectedAssessmentMode,
            //                         setupCode: state.sessionState?.schoolDetails?.setupCode,
            //                         deviceId:state.deviceState?.deviceId,
            //                         appLaunchId:state.appState.appLaunchId 
            //     }
            //     const queryParams = new URLSearchParams(JSON.stringify(appState)).toString();
            //     window.location.replace(`${urlWithParams}&state=${queryParams}`);
            //     }
            },500)
    }
    return {redirectToSCI}
};
